import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { IntroChooseInsurranceCompanyPage } from './intro-choose-insurrance-company';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    IntroChooseInsurranceCompanyPage,
  ],
  imports: [
    IonicPageModule.forChild(IntroChooseInsurranceCompanyPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class IntroChooseInsurranceCompanyPageModule {}



// WEBPACK FOOTER //
// ./src/pages/intro-choose-insurrance-company/intro-choose-insurrance-company.module.ts